export const cardActivation = {
    noValidFromDate: false,
    alwaysShowAccountName: true,
    doubleFetchEnabled: false,
    doubleFetchTimeout: 0,
};
